import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import { addUser, getUserList } from "../../services/Users-services";
import { toast } from "sonner";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import profileImage from "../../assets/images/no-profile-picture.png";
import {
  createSubject,
  deleteSubject,
  getSubjectDetails,
  updateSubject,
} from "../../services/Academic-Services";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../src/services/hostelConst";
import Select from "react-select";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../services/redux/reducers/modalSlice";
const AddSubjectForm = ({ navigate, refresh }) => {
  const dispatch = useDispatch();
  const { openModal, modalState } = useGlobalState();
  const id = modalState.id;
  const [regionOptions, setRegionOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSiteOptionsLoading, setIsSiteOptionsLoading] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [departmentHeadOptions, setDepartmentHeadOptions] = useState([]);
  const [isdepartmentHeadLoading, setIsDepartmentHeadLoading] = useState(false);
  const [isSiteSearchable, setIsSiteSearchable] = useState(true);
  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const prepareFormData = (data = null) => {
    return {
      name: data != null ? data.NAME : "",
      discription: data != null ? data.DESCRIPTION : "",
      siteId: {
        value: data != null ? data["_SITE"] : "",
        label: data != null ? data["SITE"] : "",
      },
      regionId: {
        value: data != null ? data["_REGION"] : "",
        label: data != null ? data["REGION"] : "",
      },
    };
  };
  const [loadingData, setLoadingData] = useState(modalState.isEditing);
  const [formData, setFormData] = useState(prepareFormData());
  const getDepartmentDetailsData = async (departmentId) => {
    setLoadingData(true);
    var res = await getSubjectDetails(departmentId);
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      console.log(res, "get department details");
      setFormData(prepareFormData(res.data));
    }
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    setErrors({});
    if (field == "regionId") {
      setFormData((prev) => ({ ...prev, siteId: { value: "", label: "" } }));
      setFormData((prev) => ({
        ...prev,
        departmentHead: { value: "", label: "" },
      }));
    }
    if (field == "siteId") {
      setFormData((prev) => ({
        ...prev,
        departmentHead: { value: "", label: "" },
      }));
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    let isValid = true;
    let errors = {};
    if (formData.name == "") {
      isValid = false;
      errors.name = "Subject Name is required";
    }
    if (formData.discription == "") {
      isValid = false;
      errors.discription = "Discription is required";
    }

    if (formData.regionId.value == "") {
      isValid = false;
      errors.region = "Region is required";
    }
    if (formData.siteId.value == "") {
      isValid = false;
      errors.site = "Site is required";
    }
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      var submitData = {
        description: formData.discription,
        name: formData.name,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
        regionId: formData.regionId.value,
        siteId: formData.siteId.value,
        id: modalState.isEditing ? id : "",
      };
      var res = modalState.isEditing
        ? await updateSubject(submitData)
        : await createSubject(submitData);
      if (res.status == "success") {

 callToast(
   "success",
   modalState.isEditing ? "Updated" : "Created",
   modalState.isEditing
     ? "Subject updated Successfully"
     : "Subject added successfully"
 );

 await refresh({ columnRefresh: false, isLoading: false });
 setLoading(false);
dispatch(closeModal());


      
      } else {
          console.log(res, "add subject resss");
          setLoading(false);
          showErrorMessages({
            data: res,
            navigate,
          });
       
      }
    }
  };

  const getSiteList = async (regionId, query) => {
    setIsSiteOptionsLoading(true);
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = await prepareSiteList(regionId, navigate, query);

    if (
      list.length == 1 &&
      list[0].value == data._SITE &&
      data["_SITE ACCESS_"] == null
    ) {
      setIsSiteSearchable(false);
      handleChange("siteInfo", "site", {
        value: list[0].value,
        label: list[0].label,
      });
    }

    setIsSiteOptionsLoading(false);
    if (list.length == 0) {
      setErrors((prev) => ({
        ...prev,
        site: "No site available for this region",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        site: "",
      }));
    }
    setSiteOptions(list);
  };

  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    if (
      list.length == 1 &&
      list[0].value == data._REGION &&
      data["_REGION_ACCESS_"] == null
    ) {
      setIsRegionSearchable(false);
      handleChange("siteInfo", "region", {
        value: list[0].value,
        label: list[0].label,
      });
    }
    setRegionOptions(list);
  };

  useEffect(() => {
    getRegionList();
    if (modalState.isEditing == true) {
      getDepartmentDetailsData(id);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            {/* <div
            className="position-absolute top-10 start-20 bg-primary"
            style={{
              left: "5%",
              top: "-10%",
              width: "12%",
              height: "120%",
              backgroundColor: "blue",
            }}
          ></div> */}

            <div className="d-flex">
              <div className="w-100 ps-5 pe-5">
                <form>
                  <>
                    <div className="mb-3">
                      <div className="form-row ">
                        <div class="col">
                          <label className="form-label"> Name </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Subject Name"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>
                        <div class="col mt-3">
                          <label className="form-label">Discription </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Discription"
                            value={formData.discription}
                            onChange={(e) =>
                              handleChange("discription", e.target.value)
                            }
                          />
                          {errors.discription && (
                            <small className="text-danger">
                              {errors.discription}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>{" "}
                    <div className="mb-3 ">
                      <label className="form-label">Region </label>

                      <Select
                        styles={selectStyle}
                        options={regionOptions}
                        value={
                          formData.regionId.label == ""
                            ? null
                            : formData.regionId
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "regionId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          if (newValue != null) {
                            getSiteList(newValue.value);
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {}}
                        noOptionsMessage={() => {
                          return !isRegionSearchable
                            ? "Region Access not available"
                            : "No matches found";
                        }}
                        isSearchable={isRegionSearchable}
                        placeholder="Select Region "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.region && (
                        <small className="text-danger">{errors.region}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label">Site</label>

                      <Select
                        styles={selectStyle}
                        options={siteOptions}
                        value={
                          formData.siteId.label == "" ? null : formData.siteId
                        }
                        components={
                          isSiteOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "siteId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          getSiteList(formData.regionId.value, inputValue);
                        }}
                        noOptionsMessage={() => {
                          return !isSiteSearchable
                            ? "Site Access Not available"
                            : "No matches found";
                        }}
                        isSearchable={isSiteSearchable}
                        placeholder="Select Site "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.site && (
                        <small className="text-danger">{errors.site}</small>
                      )}
                    </div>
                  </>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddSubjectForm;
